import * as React from 'react';

export default function BoxSx({ value }) {
  return (
    <div
      style={{
        border: "1px solid rgba(0, 0, 0, 0.2)",
        borderRadius: "10px",
        padding: "2px 6px"
      }}
    >
      <div style={{ textAlign: "center", display: "flex", flexDirection: "column" }}>
        <span style={{ fontFamily: "Bebas Neue, cursive", fontSize: "22px", borderBottom: "2px solid black" }} >{value}</span>
        <span style={{ fontSize: "12px" }}>Points</span>
      </div>
    </div>
  );
}
